import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const MessageChat01 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M2.66653 7.66667C2.66653 3.98477 5.65104 1 9.33263 1C13.0142 1 15.9987 3.98477 15.9987 7.66667C15.9987 8.62502 15.7965 9.53614 15.4325 10.3597L16 14.3327L12.5955 13.4815C11.631 14.0239 10.518 14.3333 9.33263 14.3333M1.00079 11.8333C1.00079 12.4323 1.12715 13.0018 1.35467 13.5165L1 15.9996L3.12762 15.4676C3.73036 15.8066 4.42596 16 5.16671 16C7.46748 16 9.33263 14.1345 9.33263 11.8333C9.33263 9.53215 7.46748 7.66667 5.16671 7.66667C2.86594 7.66667 1.00079 9.53215 1.00079 11.8333Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default MessageChat01
